var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "login-bridge" },
    [
      _c("a-spin", {
        attrs: { size: "large", tip: "正在自动登录，请稍候..." },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }